module.exports = __webpack_public_path__ + "media/2.e28e9fdf.mp3";